/** @jsxImportSource @emotion/react */
import CheckIcon from '@mui/icons-material/Check';
import * as styles from './MarketingSection.styles';
import { Constants } from 'global';
import { Box } from '@mui/material';

export const MarketingSection = () => {
  return (
    <>
      <Box css={styles.marketingWrapper} role="complementary">
        <Box css={styles.marketingLogo}>
          <a
            href={Constants.zipBusinessPaymentsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={Constants.assets.logo.light}
              width={72}
              height={32}
              alt="Zip logo"
            />
          </a>
        </Box>

        <Box css={styles.marketingContent}>
          <h2 css={styles.marketingTitle}>
            Join 60K+ businesses in Australia offering Zip
          </h2>
          <ul css={styles.featureList}>
            <li>
              <CheckIcon css={styles.featureIcon} />
              <span css={styles.featureText}>
                Get access to 2 million Australians
              </span>
            </li>
            <li>
              <CheckIcon css={styles.featureIcon} />
              <span css={styles.featureText}>
                40+ direct integrations with online and instore platforms
              </span>
            </li>
            <li>
              <CheckIcon css={styles.featureIcon} />
              <span css={styles.featureText}>
                No set up costs, ongoing account fees or lock in contracts
              </span>
            </li>
          </ul>
          <div css={styles.merchantLogos}>
            <img
              src={Constants.assets.signUpAssets.logos.qantas}
              alt="Qantas"
            />
            <img
              src={Constants.assets.signUpAssets.logos.amazon}
              alt="Amazon"
            />
            <img
              src={Constants.assets.signUpAssets.logos.jbHiFi}
              alt="JB Hi-Fi"
            />
            <img src={Constants.assets.signUpAssets.logos.uber} alt="Uber" />
            <img
              src={Constants.assets.signUpAssets.logos.cottonOn}
              alt="Cotton On"
            />
            <img
              src={Constants.assets.signUpAssets.logos.bunnings}
              alt="Bunnings"
            />
            <img src={Constants.assets.signUpAssets.logos.ebay} alt="eBay" />
            <img src={Constants.assets.signUpAssets.logos.kmart} alt="Kmart" />
          </div>
        </Box>
      </Box>
    </>
  );
};
